import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import classNames from 'classnames';

const ResumoVotacaoItem = (props) => {

    return (
        <div className="bloco-dados bloco-medium">
        <div className="bloco-title">
            {props.titulo}:
        </div>
        {props?.valor==undefined?
            <Skeleton className="bloco-skeleton" width='50%' height="calc(10px + 1.2vh)"></Skeleton>
            :<div className="bloco-valor">
                {props?.valor}
            </div>
        }
    </div>
    )
}

export default ResumoVotacaoItem;    
